import script from "./leads-list.vue?vue&type=script&setup=true&lang=js"
export * from "./leads-list.vue?vue&type=script&setup=true&lang=js"

import "./leads-list.vue?vue&type=style&index=0&id=20793d4f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20793d4f"]])

export default __exports__